var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5h-2V7.5A1.5 1.5 0 0 0 14.5 6h-2A1.5 1.5 0 0 0 11 7.5V9H9V7.5A1.5 1.5 0 0 0 7.5 6h-2A1.5 1.5 0 0 0 4 7.5V9H2V4Zm18 9.5V12a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v2.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 .5-.5v-1Z"
  })));
};
export default SvgBed;